import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface Payload {
  hospitalId: string | null;
  studyResearchList: string[];
  alertList: string[];
  // Study instance UIDs to mark as atrial fibrillation. Optional so existing
  // callers that only touch critical/research keep working unchanged.
  afList?: string[];
}

export const addStudyMarking = createAsyncThunk(
  'addStudyMarking',
  async (payload: Payload, { rejectWithValue }) => {
    payload.hospitalId = localStorage.getItem('hospitalId') || sessionStorage.getItem('hospitalId');
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(payload),
      };
      let res = await fetch(REPORTS.ADD_STUDY_MARKINGS, requestOptions);

      // Check if the response is not okay (status is 400 or other errors)
      if (!res.ok) {
        const errorData = await res.json(); // Extract error message from the res
        return rejectWithValue(errorData.msg || 'Edit Clinic failed');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
